import { render, staticRenderFns } from "./RulesPage.vue?vue&type=template&id=0b1147de&scoped=true"
import script from "./RulesPage.vue?vue&type=script&lang=js"
export * from "./RulesPage.vue?vue&type=script&lang=js"
import style0 from "./RulesPage.vue?vue&type=style&index=0&id=0b1147de&prod&lang=css"
import style1 from "./RulesPage.vue?vue&type=style&index=1&id=0b1147de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1147de",
  null
  
)

export default component.exports